import { IdentifierTypes } from 'components/base/IdentifierSelector';

export const mapDocumentTypeCode = (type: IdentifierTypes): string => {
  if (type === IdentifierTypes.IDENTIFIER) return 'DNI';
  return type.toUpperCase();
};
